/**
 * ページ内リンクスムーズスクロール
 */

(function ($) {
  $.fn.extend({
    smoothPageScroll(options) {
      const o = $.extend(
        {
          duration: 800, // 移動アニメーションの速度
        },
        options,
      );
      return this.each(function () {
        const $this = $(this);

        /**
         * index.html# で始まるアンカーをクリックした場合に処理
         */
        $this.find('a[href *= "#"]').on('click', function () {
          /**
           * アンカーの値取得、値に含まれる# 以前を削除
           * @type {string}
           */
          const href = $(this)
            .attr('href')
            .replace(/.*(#.*)/g, '$1');

          /**
           * 移動先を取得
           * @type {number}
           */
          const target = $(href === '#' || href === '' ? 'html' : href);

          /**
           * 移動先を数値で取得
           * @type {number}
           */

          const position =
            target.offset().top - $('#js-menu').outerHeight() - 20;

          /**
           * スムーススクロールを実行
           */
          $('body, html').animate(
            {
              scrollTop: position,
            },
            o.duration,
            'swing',
          );
          return false;
        });
      });
    },
  });
})(jQuery);
